import Tags from './Tags';
export default Tags;
export {tagColorNameMap as tagColorNameMap} from './Tags';
export {tagColorIconMap as tagColorIconMap} from './Tags';